import React from 'react';
import api from '../../../../../api';
import ConfirmDialog from "../../../../Modal/ConfirmDialog";
import './AddCallForward.css';

class AddCallForward extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            transferCallValue: '',
            transferCallError: false,
            country_code: "+1",
            key_press: "1",
            call_forwards:[],
            extensionExpanded: [],
            errors:[],
            errorMessage: "",
            confirmDialog:false,
            delete_index:null,
            message:""
        }
    }
    componentDidMount() {
        this.onLoad();
    }

    componentDidUpdate(prevProps) {
        if (this.props.button_action_id != prevProps.button_action_id) {
            this.onLoad();
        }
    }
    onLoad = () => {
        this.setState({loading:true});
         api.botbuilder.getcallforwarding({'workspace_id': this.props.workspace_id,branch_id:this.props.branch_id }).then(data => {
            try {
                if (data.data.length && data.status) {
                let call_forwards=data.data;
                call_forwards=call_forwards.map((forward)=>{
                    forward.extension=forward.extension!=null && forward.extension!==undefined ? String(forward.extension).replace(/\D/g,"") : "";
                    return forward;
                });
                let extensionExpanded=call_forwards.map((forward)=> !!(forward.extension && forward.extension.length));
                this.setState({
                call_forwards:call_forwards,
                extensionExpanded:extensionExpanded,
                loading:false
                });
                 this.props.updateBranchDetails(call_forwards);
            }else{
                this.setState({
                call_forwards:[{workspace_id:this.props.workspace_id,key_digit:'1',country_code:'+1',phone_number:'',forward_name:'',extension:''}],
                extensionExpanded:[false],
                loading:false
                });
            }

            }catch (err) {
                this.setState({loading:false});
                console.log(err);
                }
            }
        );   
        
    };

    phoneFormat = (p) => {
        p = p.replace(/[^\d]*/gi, "");
        if (p.length <= 3) {
            return p;
        } else if (p.length > 3 && p.length < 7) {
            p = "(" + p;
            let l30 = p.length;
            let p30 = p.substring(0, 4);
            p30 = p30 + ")";

            let p31 = p.substring(4, l30);
            let pp = p30 + p31;
            return pp;
        } else if (p.length >= 7) {
            p = "(" + p;
            let l30 = p.length;
            let p30 = p.substring(0, 4);
            p30 = p30 + ")";

            let p31 = p.substring(4, l30);
            let pp = p30 + p31;

            let l40 = pp.length;
            let p40 = pp.substring(0, 8);
            p40 = p40 + "-";

            let p41 = pp.substring(8, l40);
            let ppp = p40 + p41;
            let maxphonelength = 13;
            let finalPhone = ppp.substring(0, maxphonelength);
            return finalPhone;
        }
    };

    countryCodeHandler = (e,index) => {
        let call_forward_arr=this.state.call_forwards;
        call_forward_arr=call_forward_arr.map((forward,i)=>{
            forward.country_code=i===index ? e.target.value:forward.country_code;
            return forward;
        })
        this.setState({call_forwards:call_forward_arr});
    }

    keyPressHandler = (e) => {
        this.setState({ key_press: e.target.value })
    }

    handleTransferCall = (e,index) => {
        let inputValue;
        inputValue = this.phoneFormat(e.target.value);
        let call_forward_arr=this.state.call_forwards;
        call_forward_arr=call_forward_arr.map((forward,i)=>{
            forward.phone_number=i===index ? inputValue:forward.phone_number;
            return forward;
        });
        this.setState({call_forwards:call_forward_arr});
        
    }
    validateRules = (rules) => {
        const errors = [];
        const phoneNumberRegex = /^\(\d{3}\)\d{3}-\d{4}$/;

        // Check for duplicate phone numbers
        const phoneCount = {};
        rules.forEach((rule) => {
            if (rule.phone_number) {
                const num = rule.phone_number.trim();
                phoneCount[num] = (phoneCount[num] || 0) + 1;
            }
        });

        rules.forEach((rule, index) => {
            let err = {};
            let iserr = false;
            let extDigits = (rule.extension || "").replace(/\D/g, "");

            if (!rule.phone_number || typeof rule.phone_number !== 'string' || rule.phone_number.trim() === '') {
                err = {
                    index: index,
                    phone_number: 'This field is required.'
                };
                iserr = true;
            } else if (!phoneNumberRegex.test(rule.phone_number)) {
                err = {
                    ...err,
                    index: index,
                    phone_number: 'Phone number is not valid.'
                };
                iserr = true;
            } else if (phoneCount[rule.phone_number.trim()] > 1) {
                err = {
                    ...err,
                    index: index,
                    phone_number: 'Phone number already exists.'
                };
                iserr = true;
            }

            if (extDigits.length > 10) {
                err = {
                    ...err,
                    index: index,
                    extension: 'Extension cannot exceed 10 digits.'
                };
                iserr = true;
            }

            // Validate forward_name
            if (!rule.forward_name || typeof rule.forward_name !== 'string' || rule.forward_name.trim() === '') {
                err = {
                    ...err,
                    index: index,
                    forward_name: 'This field is required.'
                };
                iserr = true;
            }

            if (iserr) {
                errors.push(err);
            }
        });

        return errors;
    }

    getErrorMessage = (errors) => {
        let hasRequired = false;
        let hasDuplicate = false;
        
        errors.forEach(error => {
            if (error.phone_number === 'This field is required.' || error.forward_name === 'This field is required.') {
                hasRequired = true;
            }
            if (error.phone_number === 'Phone number already exists.') {
                hasDuplicate = true;
            }
        });
        
        if (hasRequired && hasDuplicate) {
            return "Fill in all the required fields and remove duplicate phone numbers.";
        } else if (hasRequired) {
            return "Fill in all the required fields.";
        } else if (hasDuplicate) {
            return "Remove duplicate phone numbers.";
        }
        return "Fix the errors in the form above.";
    }

    saveForwardCall = (e) => {
     let prevrules=this.state.call_forwards;
        let validate_errors=this.validateRules(prevrules);
        if(validate_errors.length>0){
            const errorMessage = this.getErrorMessage(validate_errors);
            this.setState({errors:validate_errors, errorMessage: errorMessage});
            return false;
        }else{
            this.setState({errors:[], errorMessage: ""})
        }
        
        this.setState({ loading: true, disablebutton: true })
        let frules=this.state.call_forwards;
        if(this.state.call_forwards.length>0){
            frules=frules.map((rule)=>{
                rule.forward_name=rule.forward_name.trim();
                rule.extension=(rule.extension || "").replace(/\D/g, "");
                return rule;
            });
            this.setState({call_forwards:frules});
        }
        

        api.botbuilder.saveCallFarwordNumber({data:frules,workspace_id:this.props.workspace_id,branch_id:this.props.branch_id}).then((res) => {
            let call_forwards=res.data || [];
            call_forwards=call_forwards.map((forward)=>{
                forward.extension=forward.extension!=null && forward.extension!==undefined ? String(forward.extension).replace(/\D/g,"") : "";
                return forward;
            });
            let extensionExpanded=call_forwards.map((forward)=> !!(forward.extension && forward.extension.length));
            this.setState({ loading: false, disablebutton: false,message:"Rules saved successfully.",call_forwards:call_forwards, extensionExpanded:extensionExpanded },()=>{
                setTimeout(() => {
                                    this.setState({message:""});
                                }, 4000);
            });
            this.props.popupClose()
            this.props.updateBranchDetails(res.data)
        }).catch((err) => {
            this.setState({ loading: false, disablebutton: false })
            console.log(err);
        })

    }
    updateName=(e,index)=>{
        let call_forward_arr=this.state.call_forwards;
        let name=e.target.value;
        name=name.trimStart();
        call_forward_arr=call_forward_arr.map((forward,i)=>{
            forward.forward_name=i==index ? name:forward.forward_name;
            return forward;
        })
        this.setState({call_forwards:call_forward_arr});
    }
    addnewrule=()=>{
        let rule={workspace_id:this.props.workspace_id,key_digit:'1',country_code:'+1',phone_number:'',forward_name:'',extension:''}
        let call_forward_arr=this.state.call_forwards;
         call_forward_arr.push(rule);
        this.setState({
            call_forwards:call_forward_arr,
            extensionExpanded: [...this.state.extensionExpanded, false],
        });
    }
    deleteRule=(e,index,id)=>{
       this.setState({delete_index:{index:index,id:id},confirmDialog:true});
    }
    deleteCredentials=()=>{
             this.setState({loading:true,confirmDialog:false})
             let delete_index=this.state.delete_index;
             let rules=this.state.call_forwards;
             if(delete_index.id){
                    try {
                    api.botbuilder.deleteCallFarword({id:delete_index.id,workspace_id:this.props.workspace_id,branch_id:this.props.branch_id}).then(res=>{
                        if(res.status){
                            let rules=this.state.call_forwards;
                            rules=rules.filter(rule=>rule.id!=delete_index.id);
                            const nextExp = this.state.extensionExpanded.filter((_, i) => i !== delete_index.index);
                            this.setState({loading:false,call_forwards:rules, extensionExpanded: nextExp, delete_index:null,confirmDialog:false,message:'Rule deleted successfully.'},()=>{
                                setTimeout(() => {
                                    this.setState({message:""});
                                }, 4000);
                            });
                             this.props.updateBranchDetails(res.data);
                        }
                    });
                    
                } catch (error) {
                    this.setState({loading:false,confirmDialog:false})
                    console.log(error)
                }
             }else{
                rules.splice(delete_index.index,1);
                const nextExp = this.state.extensionExpanded.filter((_, i) => i !== delete_index.index);
                this.setState({loading:false,call_forwards:rules, extensionExpanded: nextExp, delete_index:null,confirmDialog:false,message:'Rule deleted successfully.'},()=>{
                    setTimeout(() => {
                                    this.setState({message:""});
                                }, 4000);
                });
             }
            
         
       
    }
    toggleConfirmModal=()=>{
        this.setState({confirmDialog:!this.state.confirmDialog});
    }

    render() {
        return (
            <div>
                 <ConfirmDialog
                            show={this.state.confirmDialog}
                            toggleModal={this.deleteCredentials}
                            closeAction={this.toggleConfirmModal}
                            title="Confirm your action"
                            message={"Do you really want to delete this rule ?"}
                        />
                {this.state.loading && (
                    <div className="ui loading form"></div>
                )}
                <div className="yr-chat-round-box yr-closebtn">
                    <button type="button" class="close linear-gradient" onClick={() => this.props.popupClose()}>&#10006;</button>
                    {
                        this.props.bot_type == 'Voice' ? 
                        <div className='col-md-12'>If someone presses
                            <select  
                                onChange={(e) => this.keyPressHandler(e)} 
                                value={this.state.key_press}
                                style={{ margin: "0px 5px", height: "30px", background: "white", border: "1px solid #cacaca", fontSize: "12px", borderRadius: "3px", color: "#959393" }}
                            >
                                    <option>0</option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                    <option>8</option>
                                    <option>9</option>
                            </select>
                            at any time during the call, forward the call to.
                        </div> : 
                        <div className='col-md-12' style={{marginTop:'10px',marginLeft:'-10px'}}>If someone asks to speak to a human or representative, forward the call to: </div>
                    }
                    <div className='row' style={{marginLeft:'1px'}}>
                       
                   <button class="btn add-link pull-right" style={{width: "100%", textAlign: "left",marginLeft:'0px'}} onClick={()=>this.addnewrule()}>+Add call forwarding rule</button>
                     {this.state.message && <div className='ui message green' style={{marginTop:'10px',textAlign:'center'}}>{this.state.message}</div>}
                     {this.state.errorMessage && <div className='ui message red' style={{marginTop:'10px',width:'100%'}}>{this.state.errorMessage}</div>}
                    </div>
                  {this.state.call_forwards.length>0 && <div className='row' >
                   
                    {this.state.call_forwards.map((forward_item,index)=>{
                         let err=this.state.errors.filter(er=>er.index==index);
                         const extRowVisible = this.state.extensionExpanded[index];
                         console.log('erros',err)
                 return(<>
                    <div className={`col-md-11 ${index === 0 ? 'primaryborder' : ''}`} style={{display: 'flex', columnGap: 10, marginTop: 10}} key={index}>
                        <div className='form-group'>
                            <input type='tetx' className={`form-control ${err && err[0]?.forward_name ? 'input-error' : ''}`} name='name' value={forward_item.forward_name} onChange={(e)=>this.updateName(e,index)} placeholder='Forward Name ' />
                    </div>
                    <div className='form-group' style={{paddingLeft:'8px',width:'40%'}}>
                            <select onChange={(e) => this.countryCodeHandler(e,index)} value={forward_item.country_code} className='form-control'>
                                {this.props.defaultCountryCodeLists && this.props.defaultCountryCodeLists.map((value, index) => {
                                    return (
                                        <option value={value.country_code} >{value.country_name}</option>
                                    )
                                })}
                                <optgroup label="Other countries">
                                    {this.props.countryCodeLists && this.props.countryCodeLists.map((value, index) => {
                                        return (
                                            <option value={value.country_code}  >{value.country_name}</option>)
                                    })}
                                </optgroup>
                            </select>
                            </div>
                             <div className='form-group'>
                                <input
                                    name="phone_for_transfer_call"
                                    onChange={(e) => this.handleTransferCall(e,index)}
                                    value={forward_item.phone_number}
                                    className={`form-control ${err && err[0]?.phone_number ? 'input-error' : ''}`}
                                    type="text"
                                    placeholder="(000)000-0000"
                                />
                            </div>
                            
                    </div>
                    <div className='col-md-1' style={{display: 'flex', columnGap: 10, marginTop: index===0 ? '30px' : '18px'}} key={index}>
                        <span style={{color:'red',cursor:'pointer',marginTop:index==0 ? '-10px' : '0px'}} onClick={(e)=>this.deleteRule(e,index,forward_item.id || null)} title="Delete rule" ><i style={{color:'red',cursor:'pointer'}} className='fa fa-trash'></i></span>
                    </div>
                    {!extRowVisible ? (
                    <div className="col-md-11" style={{ marginTop: -10 }}>
                            <button
                                type="button"
                                className="btn add-link"
                                style={{ width: "100%", textAlign: "left", marginLeft: 0, padding: 0, fontSize: 12 }}
                                onClick={() => {
                                    let extensionExpanded=this.state.extensionExpanded;
                                    extensionExpanded=extensionExpanded.map((v,i)=> i===index ? true : v);
                                    this.setState({ extensionExpanded:extensionExpanded });
                                }}
                            >
                                + Add Extension
                            </button>
                    </div>
                        ) : (
                        <>
                            <div className="col-md-12" style={{ marginTop: 6, marginBottom: 4 }}>
                                <label style={{ fontSize: 12, display: "block", marginBottom: 0 }}>Extension Number</label>
                            </div>
                            <div className="col-md-11" style={{ marginBottom: 0 }}>
                                <div className="form-group" style={{ width: "64%" }}>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        autoComplete="off"
                                        className={`form-control ${err && err[0]?.extension ? "input-error" : ""}`}
                                        style={{ width: "100%" }}
                                        value={forward_item.extension || ""}
                                        onChange={(e) => {
                                            let call_forward_arr=this.state.call_forwards;
                                            let digits=e.target.value.replace(/\D/g, "");
                                            call_forward_arr=call_forward_arr.map((forward,i)=>{
                                                forward.extension=i===index ? digits : forward.extension;
                                                return forward;
                                            });
                                            this.setState({ call_forwards:call_forward_arr });
                                        }}
                                        placeholder="Optional"
                                    />
                                    {err && err[0]?.extension && (
                                        <div style={{ color: "#c00", fontSize: 12, marginTop: 4 }}>{err[0].extension}</div>
                                    )}
                                </div>
                            </div>
                            <div className='col-md-1' style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', columnGap: 10}}>
                                <span style={{color:'red',cursor:'pointer',marginTop:index==0 ? '-10px' : '0px'}} onClick={() => {
                                    let call_forward_arr=this.state.call_forwards;
                                    call_forward_arr=call_forward_arr.map((forward,i)=>{
                                        forward.extension=i===index ? "" : forward.extension;
                                        return forward;
                                    });
                                    let extensionExpanded=this.state.extensionExpanded;
                                    extensionExpanded=extensionExpanded.map((v,i)=> i===index ? false : v);
                                    this.setState({ call_forwards:call_forward_arr, extensionExpanded:extensionExpanded });
                                }} title="Remove extension" ><i style={{color:'red',cursor:'pointer'}} className='fa fa-trash'></i></span>
                            </div>
                        </>
                        )}
                    </>);
                    })}
                    
                    {this.state.call_forwards.length>0 &&<div className='col-md-12'>
                         <p><strong  className='text-info'>Note:</strong> First forward rule is primary forward rule.</p>
                    </div>}
                    
                </div>}
                     {this.state.transferCallError && <div style={{ color: "red", marginTop: "10px" }}>Please write a valid phone number</div>}
                </div>
                <div className="row">
                    {this.state.call_forwards.length>0 && <div className="col-12 d-flex justify-content-end">
                        <button type="reset" class="btn linear-gradient-cancel yr-cancelbtn mg-r" onClick={() => this.props.popupClose()} ><span> Close </span></button>
                        <button type="submit" disabled={this.state.disablebutton} className="btn linear-gradient yr-submitbtn" onClick={(e) => this.saveForwardCall(e)}>Save</button>
                    </div>}
                </div>
            </div>
        )
    }
}


export default AddCallForward;